import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { loginSuccess } from './Reducer/userReducer';
import Login from './component/LoginRegister/Login';
import Dashboard from './component/dashboard/Dashboard';
import Skeleton from './component/SkeletonLoader';

function App() {
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state) => state.user);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    try {
      const storedUser = localStorage.getItem('user');
      if (storedUser) {
        dispatch(loginSuccess(JSON.parse(storedUser)));
      }
    } catch (err) {
      console.error('Failed to rehydrate user state:', err.message);
    } finally {
      setLoading(false);
    }
  }, [dispatch]);

  // Show a Skeleton layout for Sidebar and Header while loading
  if (loading) {
    return (
      <Skeleton />  
    );
  }

  return (
    <Router>
      <Routes>
        <Route
          path="/login"
          element={!isAuthenticated ? <Login /> : <Navigate to="/dashboard" replace />}
        />
        <Route
          path="/dashboard/*"
          element={isAuthenticated ? <Dashboard /> : <Navigate to="/login" replace />}
        />
        <Route path="/dashboard/home" element={<Dashboard />} />
        <Route path="/" element={<Navigate to={isAuthenticated ? "/dashboard" : "/login"} replace />} />
      </Routes>
    </Router>
  );
}

export default App;